import { EquipmentTestLibraryDao } from '@rock/db-admin';
import type { EquipmentTestLibraryEntryId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const equipmentTestLibraryDao = new EquipmentTestLibraryDao();

/**
 * The whole test library, unfiltered — space/type/status/search filtering happens in the page. The
 * library is a curated set in the dozens-to-low-hundreds, so one subscription filtered in memory
 * keeps the filter UI instant (a filter change is a re-render, not a round trip).
 */
export const equipmentTestLibraryState = equipmentTestLibraryDao.entriesAtom();

export const equipmentTestLibraryEntryState = atomFamily(
    (entryId: EquipmentTestLibraryEntryId) => equipmentTestLibraryDao.entryAtom(entryId),
    shallowEqual,
);
